// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let IconV5 = require("./IconV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerNeedPropertyAttributes_buyerNeedV5_graphql = require("../../../__generated__/BuyerNeedPropertyAttributes_buyerNeedV5_graphql.bs.js");
let BuyerNeedPropertyAttributes_propertyTypes_graphql = require("../../../__generated__/BuyerNeedPropertyAttributes_propertyTypes_graphql.bs.js");

let convertFragment = BuyerNeedPropertyAttributes_propertyTypes_graphql.Internal.convertFragment;

function BuyerNeedPropertyAttributes$Attributes(props) {
  let __icon = props.icon;
  let minBeds = props.minBeds;
  let icon = __icon !== undefined ? Primitive_option.valFromOption(__icon) : "home";
  let propertyTypes = RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, props.propertyTypes);
  let __x = propertyTypes.map(x => x.displayName);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          Stdlib_Option.getOr(Stdlib_Option.map(icon, icon => JsxRuntime.jsx(IconV5.make, {
            icon: icon,
            className: "text-zinc-600"
          })), null),
          JsxRuntime.jsx("span", {
            children: Utils.$$Array.pseudoJoin(", ", " or ", __x).join(""),
            className: "text-zinc-700"
          })
        ],
        className: "flex flex-row items-start gap-2"
      }),
      minBeds !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(IconV5.make, {
              icon: "bed",
              className: "relative top-0.5 text-zinc-600"
            }),
            JsxRuntime.jsx("span", {
              children: minBeds.toString() + `+`,
              className: "text-zinc-700"
            })
          ],
          className: "flex flex-row items-start gap-2"
        }) : null
    ],
    className: "flex flex-row items-start gap-4"
  });
}

let convertFragment$1 = BuyerNeedPropertyAttributes_buyerNeedV5_graphql.Internal.convertFragment;

function BuyerNeedPropertyAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property criteria",
    children: JsxRuntime.jsx(BuyerNeedPropertyAttributes$Attributes, {
      propertyTypes: match.propertyTypes.map(v => v.fragmentRefs),
      minBeds: match.minBeds,
      icon: props.icon
    })
  });
}

let Attributes = {
  make: BuyerNeedPropertyAttributes$Attributes
};

let make = BuyerNeedPropertyAttributes;

exports.Attributes = Attributes;
exports.make = make;
/* Utils Not a pure module */
